export default __webpack_public_path__ + "static/media/edo.e9c7a8c8.jpg";